import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { getBlog } from "@/lib/api";
import Newsletter from "@/components/Newsletter";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return "";
  }
}

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    getBlog().then(setPosts).catch(() => {});
  }, []);

  return (
    <div data-testid="blog-page" className="pt-32">
      <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-16">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="max-w-2xl">
          <p className="text-xs tracking-accent uppercase text-amber-500 mb-4">The Journal</p>
          <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tight">News & Notes</h1>
          <p className="mt-6 text-zinc-400 text-lg leading-relaxed">
            Cover reveals, writing craft, behind-the-scenes of The Luminaria Chronicles, and the strange myths that fuel the stories.
          </p>
        </motion.div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-28">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post, i) => (
            <motion.article
              key={post.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`blog-card-${post.slug}`}
            >
              <Link to={`/blog/${post.slug}`} className="group block border border-zinc-800/60 bg-zinc-900/40 hover:-translate-y-1 transition-transform duration-300">
                <div className="overflow-hidden aspect-[16/10]">
                  <img src={post.cover_image} alt={post.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-[10px] tracking-accent uppercase text-amber-500">{post.category}</span>
                    <span className="text-xs text-zinc-600">{formatDate(post.published_at)}</span>
                  </div>
                  <h2 className="font-display text-xl font-semibold group-hover:text-amber-500 transition-colors leading-snug">{post.title}</h2>
                  <p className="mt-3 text-sm text-zinc-400 line-clamp-3 leading-relaxed">{post.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-xs tracking-accent uppercase text-zinc-300 group-hover:gap-3 transition-all">
                    Read <ArrowRight size={14} />
                  </span>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </section>

      <Newsletter />
    </div>
  );
}
